var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6335 2.3658C21.2923 2.0258 20.7835 1.90954 20.3298 2.0733L2.82977 8.32344C2.35852 8.49094 2.03227 8.9247 2.00227 9.42346C1.97227 9.92348 2.24227 10.3922 2.69102 10.6172L8.42352 13.4823L15.7498 8.24969L10.516 15.5774L13.381 21.31C13.5948 21.7337 14.0285 22 14.4998 22C14.526 22 14.551 21.9987 14.576 21.9975C15.076 21.9675 15.5098 21.6425 15.6785 21.17L21.9285 3.66958C22.0898 3.21582 21.9748 2.70706 21.6335 2.3658Z",
    fill: "#314ACE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconBlue);
export default __webpack_public_path__ + "static/media/send-icon-blue.9b3fef5e79237cb2977d44a842b79919.svg";
export { ForwardRef as ReactComponent };